import i18n from 'i18n'

export const DEFAULT_QUESTION_TEXT = i18n.t('Question')
export const MIN_QUESTIONS_COUNT = 1
export const MAX_QUESTIONS_COUNT = 1000
export const DEFAULT_QUESTION_ANSWER_COUNT = 4
